import { initializeVue } from "@/core/app-setup";
import MediaRecorderView from "@/experiences/media-recorder/views/MediaRecorderView.vue";
window.initializeMediaRecorder = (elSelector, rootProps) => {
    return initializeVue(elSelector, MediaRecorderView, { rootProps });
};
